/* pantallas-alumno (B): LA CAJA DE TEXTO DE LA CASA Y LA CAJA LARGA CON CONTADOR (piezas nuevas de la
   parte 2).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   - Caja de texto: la del Panel, 44 (48 en el celular, con 16 px), fondo #0E0E0E, borde #262626, radio
     12; etiqueta arriba de 13 px seminegrita #9A9A9A; foco con borde #F27A2E; error con borde #F87171
     y el texto rojo debajo. `adornoDerecha` (el ojo de la contrasena) va adentro a la derecha. `clase`
     agrega clases a la caja (el codigo de grupo en letra de ancho fijo, el de 6 digitos de 56).
   - Caja larga con contador: fondo #0E0E0E, borde #262626, radio 14, ALTO FIJO de 110 (`alto={140}`
     en Gana creditos): el texto se desplaza por dentro y nada brinca. Texto 15 (16 en el celular).
     Debajo el contador de 13 px #9A9A9A (el TEXTO del contador lo da quien la usa, con su formato de
     hoy); con `alTope`, el contador en naranja.

   `onCambio` recibe el texto. Todo lo demas (`type`, `maxLength`, `autoComplete`...) pasa a la caja. */
import React from 'react';
import { AlertCircle } from 'lucide-react';

function ErrorDeCaja({ id, error }) {
  return (
    <p id={id} data-parte="error" className="flex items-start gap-1.5 text-[13px] leading-[18px] text-[#F87171]">
      <AlertCircle className="w-3.5 h-3.5 shrink-0 mt-0.5" aria-hidden="true" />
      <span className="min-w-0 break-words">{error}</span>
    </p>
  );
}

function Etiqueta({ id, etiqueta }) {
  return etiqueta ? <label htmlFor={id} className="text-[13px] font-semibold text-[#9A9A9A]">{etiqueta}</label> : null;
}

export default function CajaDeTexto({
  id, etiqueta, valor, onCambio, error, adornoDerecha, clase = '', testid, type = 'text', disabled = false, ...resto
}) {
  const idError = error ? `${id}-error` : undefined;
  return (
    <div data-testid={testid} className="flex flex-col gap-1.5 min-w-0">
      <Etiqueta id={id} etiqueta={etiqueta} />
      <div className="relative">
        <input
          id={id}
          type={type}
          value={valor}
          disabled={disabled}
          aria-invalid={error ? 'true' : undefined}
          aria-describedby={idError}
          onChange={(e) => { if (onCambio) onCambio(e.target.value); }}
          className={`w-full h-12 md:h-11 px-3.5 ${adornoDerecha ? 'pr-12 ' : ''}rounded-xl bg-[#0E0E0E] border text-[16px] md:text-[14px] text-[#F4F4F3] placeholder-[#6A6A6A] outline-none focus:border-[#F27A2E] disabled:opacity-45 disabled:cursor-not-allowed ${error ? 'border-[#F87171]' : 'border-[#262626]'} ${clase}`.trim()}
          {...resto}
        />
        {adornoDerecha ? <div className="absolute right-1 top-1/2 -translate-y-1/2 flex items-center">{adornoDerecha}</div> : null}
      </div>
      {error ? <ErrorDeCaja id={idError} error={error} /> : null}
    </div>
  );
}

export function CajaLargaConContador({
  id, etiqueta, valor, onCambio, contador, alTope = false, alto = 110, error, testid, disabled = false, ...resto
}) {
  const idError = error ? `${id}-error` : undefined;
  const altoClase = alto === 140 ? 'h-[140px]' : 'h-[110px]';
  return (
    <div data-testid={testid} className="flex flex-col gap-1.5 min-w-0">
      <Etiqueta id={id} etiqueta={etiqueta} />
      <textarea
        id={id}
        value={valor}
        disabled={disabled}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={idError}
        onChange={(e) => { if (onCambio) onCambio(e.target.value); }}
        className={`w-full ${altoClase} resize-none overflow-y-auto px-3.5 py-3 rounded-[14px] bg-[#0E0E0E] border text-[16px] md:text-[15px] leading-snug text-[#F4F4F3] placeholder-[#6A6A6A] outline-none focus:border-[#F27A2E] disabled:opacity-45 ${error ? 'border-[#F87171]' : 'border-[#262626]'}`}
        {...resto}
      />
      {contador !== undefined && contador !== null ? (
        <p data-parte="contador" aria-live="polite" className={`text-[13px] tabular-nums ${alTope ? 'text-[#F7A06A]' : 'text-[#9A9A9A]'}`}>{contador}</p>
      ) : null}
      {error ? <ErrorDeCaja id={idError} error={error} /> : null}
    </div>
  );
}
